'use client'
import { Box, Typography } from '@mui/material'
import GlobalStyles from '@app/GlobalStyles'
import { BodyContainer } from '@app/RootLayoutChildren'
import { pageContent } from './Content'

const PageContent = () => {
  return (
    <>
      <GlobalStyles />
      <BodyContainer>
        <Typography variant="h1" mb={7} align="center">
          {pageContent.pageTitle}
        </Typography>
        {pageContent.sections.map((section, index) => (
          <Box
            component="section"
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 2,
              mb: 3
            }}
            key={index}
          >
            <Typography variant="body1" fontWeight={600} sx={{ lineHeight: 1.6 }}>
              {index + 1}.
            </Typography>
            {section.content}
          </Box>
        ))}
      </BodyContainer>
    </>
  )
}

export default PageContent
